// extracted by mini-css-extract-plugin
export default {"CtaButtons":"CtaButtons-module__CtaButtons--Hth5Y","Button":"CtaButtons-module__Button--GI2KJ"};